import { useColumns } from '../hooks/useColumns';
import { SingleFormatedTutor, TutorsResponse } from '../types';
import { Table, Modal } from '@octano/global-ui';
import { useState } from 'react';

import { useTexts } from '../hooks/useTexts';
import { AssignTutorModal } from './AssignTutorModal';

type Props = {
  tutorsData: TutorsResponse;
  refresh: Function;
};

export function TutorsTable({ tutorsData, refresh }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const texts = useTexts();
  const [modalData, setModalData] = useState<SingleFormatedTutor>();
  const data = useColumns(
    tutorsData.studentPlansAndTutors.studyPlans,
    setIsOpen,
    setModalData,
  );
  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={() => setIsOpen(false)}
        size="lg"
        children={
          <AssignTutorModal
            allTutors={tutorsData.allTutors}
            toggle={() => setIsOpen(false)}
            modalData={modalData}
            refresh={refresh}
          />
        }
      />
      <Table
        data={data.studyPlans}
        noResultsText={useTexts().noResults}
        columns={[
          {
            headerText: texts.table.studyPlan,
            columnName: 'name',
            width: '25%',
            thClassName: 'text-center',
            tdClassName: 'text-center',
          },
          {
            headerText: texts.table.nameAndId,
            columnName: 'tutor',
            width: '25%',
            thClassName: 'text-center',
            tdClassName: 'text-center',
          },
          {
            headerText: texts.table.email,
            columnName: 'tutorEmail',
            width: '25%',
            thClassName: 'text-center',
            tdClassName: 'text-center',
          },
          {
            headerText: texts.table.action,
            columnName: 'action',
            width: '25%',
            thClassName: 'text-center',
            tdClassName: 'text-center',
          },
        ]}
      />
    </>
  );
}
